import React, { useEffect } from 'react';
import { createStructuredSelector } from 'reselect';
import { useHistory, useLocation } from 'react-router';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { setLocalStorageItem } from '../../utils/localStorage';
import { useInjectReducer } from '../../utils/injectReducer';
import reducer from '../profile/reducer';
import { getUserInfoAction } from '../profile/actions';

export const LoginEmailWrapper = ({ onGetUserInfo }) => {
	useInjectReducer({ key: 'profileModalReducer', reducer });

	const { search } = useLocation();

	const query = new URLSearchParams(search);

	const history = useHistory();

	useEffect(() => {
		if (query.has('token')) {
			const token = query.get('token');

			setLocalStorageItem('user', token);

			onGetUserInfo(history);

			query.delete('token');
		}

		history.push(`/not_digital/?${query}`);
	}, []);

	return <></>;
};

const mapStateToProps = createStructuredSelector({});

const mapDispatchToProps = {
	onGetUserInfo: getUserInfoAction,
};

const LoginEmail = connect(mapStateToProps, mapDispatchToProps)(LoginEmailWrapper);

LoginEmailWrapper.propTypes = {
	onGetUserInfo: PropTypes.func.isRequired,
};

export { LoginEmail };
